import { SIPPlan, STPPlan, SWPPlan } from "../../types";
import { api } from "../axios";

export interface GetSTPPlansResponse {
  next: string;
  previous: string;
  results: STPPlan[];
  count: number;
  active_count: number;
  monthly_amount: string;
}

export async function getSTPPlans(
  page: number,
  pageSize: number,
  investmentAccountGuid: string,
  search?: string
): Promise<GetSTPPlansResponse> {
  return api.get("stp/", {
    params: {
      page,
      page_size: pageSize,
      investment_account_guid: investmentAccountGuid,
      search,
    },
  });
}

export interface FetchSwpDataResponse {
  next: string;
  previous: string;
  results: SWPPlan[];
  count: number;
  active_count: number;
  monthly_amount: string;
}

export function fetchSwpPlans(
  page: number,
  pageSize: number,
  investmentAccountGuid: string,
  search?: string
): Promise<FetchSwpDataResponse> {
  return api.get(`swp/`, {
    params: {
      investment_account_guid: investmentAccountGuid,
      page,
      page_size: pageSize,
      search,
    },
  });
}

export interface SipPlansResponse {
  next: string;
  previous: string;
  results: SIPPlan[];
  count: number;
  active_count: number;
  monthly_amount: string;
}

export async function fetchSipPlans({
  investmentAccountGuid,
  page,
  pageSize,
  search,
  sort,
}: {
  investmentAccountGuid: string;
  page: number;
  pageSize: number;
  search?: string;
  sort?: Array<{ id: string; desc: boolean }>;
}): Promise<SipPlansResponse> {
  return api.get(`xsip/`, {
    params: {
      investment_account_guid: investmentAccountGuid,
      page,
      page_size: pageSize,
      search,
      ordering: sort?.map((s) => `${s.desc ? "-" : ""}${s.id}`).join(","),
    },
  });
}
